import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=e505f5d0&"
import script from "./FormError.vue?vue&type=script&lang=js&"
export * from "./FormError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports